import { useState, useEffect } from 'react';

import isNil from 'lodash/isNil';
import isNaN from 'lodash/isNaN';
import { ONE_DAY_MILLI_SEC } from 'commons-ui';
import { WithdrawalsFilters } from './constants';
import useService from './useService';

const useUserWithdrawals = () => {
	const { getUserWithdrawals } = useService();
	const [userWithdrawalsData, setUserWithdrawalsData] = useState<any>({ data: [], rowCount: 0 });
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [filters, setFilters] = useState<WithdrawalsFilters>();
	const [showLoader, setShowLoader] = useState<boolean>(false);

	const fetchUserWithdrawalsData = async () => {
		try {
			setShowLoader(true);
			const result = await getUserWithdrawals(filters);

			setUserWithdrawalsData({ data: result?.data, rowCount: result?.rowCount });
			setForceUpdate(true);
		} catch (error: any) {
			setUserWithdrawalsData({ data: [], rowCount: 0 });
			setForceUpdate(true);
		} finally {
			setShowLoader(false);
		}
	};

	useEffect(() => {
		if (filters) {
			fetchUserWithdrawalsData();
		}
	}, [filters]);

	const getUserWithdrawalsData = () => {
		setForceUpdate(false);
		return userWithdrawalsData;
	};

	const handleFilterSubmit = (submittedFilters: { fromToDate?: Date[]; transactionId?: number }) => {
		const { fromToDate, transactionId } = submittedFilters;

		if (fromToDate && fromToDate.length === 2) {
			setFilters({ fromToDate: [fromToDate[0].getTime(), fromToDate[1].getTime() + ONE_DAY_MILLI_SEC] });
		} else if (!isNil(transactionId) && !isNaN(transactionId)) {
			setFilters({ transactionId });
		}
	};

	return { getUserWithdrawalsData, handleFilterSubmit, forceUpdate, showLoader };
};

export default useUserWithdrawals;
